<section>
    <header>
      <div class="row">
        <div class="col">
          <label class="label max-width" translate>language</label>
          <ngx-language-select></ngx-language-select>
        </div>
      </div>
      <h1 class="title" translate>change_password_title</h1>
      <p class="subtitle" translate>change_password_subtitle</p>
    </header>
    <ngx-change-password-form [loading]="loading$ | async" (output)="save($event)"></ngx-change-password-form>
</section>